"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CacheObservable = exports.ClearCache = void 0;
var core_1 = require("@athena-portal/core");
var Types_1 = require("../Types");
var operators_1 = require("rxjs/operators");
/**
 * Decorator for clearing cache.
 *
 * Clear all items by identified by key prefix.
 *
 * @key     Cache key used to identify value.
 * @storage (Optional)Storage of cache.
 */
function ClearCache(key, storage) {
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            core_1.iocContainer
                .get(Types_1.Types.CacheManager)
                .clearCache(key, storage);
            return method.apply(this, args);
        };
    };
}
exports.ClearCache = ClearCache;
/**
 * Decorator for caching observable.
 *
 * @secure        (Optional)Weather or not to use encryption. Requires application guard.
 * @key           (Optional)Default key override. Default is method name.
 * @timeToLiveSec (Optional)Default time to live override.
 * @storage       (Optional)Default storage override..
 */
function CacheObservable(secure, key, timeToLiveSec, storage) {
    var useEncryption = secure ? true : false;
    return function (target, propertyKey, descriptor) {
        var method = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var cacheManager = core_1.iocContainer.get(Types_1.Types.CacheManager);
            var cacheKey = key || propertyKey + args.toString();
            if (cacheManager.isCached(cacheKey, storage)) {
                var cachedValue = cacheManager.tryGetObservable(cacheKey, storage);
                if (cachedValue != null) {
                    return cachedValue;
                }
            }
            var result = method.apply(this, args).pipe((0, operators_1.share)());
            cacheManager.saveObservable(cacheKey, result, useEncryption, storage, timeToLiveSec);
            return result;
        };
    };
}
exports.CacheObservable = CacheObservable;
//# sourceMappingURL=Cache.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-services/dist/decorators/Cache.js
// module id = 643
// module chunks = 0